"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const compact_1 = __importDefault(require("lodash/compact"));
const defaultKey = ['change-reviewer'];
const keys = {
    default: defaultKey,
    selections: (params) => {
        return (0, compact_1.default)([...defaultKey, 'selections', params]);
    }
};
exports.default = keys;
